import type { DashboardInfoCoreTrackResponse } from '@/types/dashboard'

export const getUserInitials = (
  selectedDashboardInfo: DashboardInfoCoreTrackResponse | null,
) =>
  `${
    selectedDashboardInfo?.personalInfo?.owner_FirstName
      ?.toUpperCase()
      ?.charAt(0) ?? ''
  }${
    selectedDashboardInfo?.personalInfo?.owner_LastName
      ?.toUpperCase()
      ?.charAt(0) ?? ''
  }`
